const KEY = 'oem_debug_log'
const MAX_ENTRIES = 500

export interface DebugEntry {
  ts: string       // ISO
  tag: string
  msg: string
  data?: unknown
}

function load(): DebugEntry[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]')
  } catch {
    return []
  }
}

export function debugLog(tag: string, msg: string, data?: unknown): void {
  try {
    const entries = load()
    entries.push({ ts: new Date().toISOString(), tag, msg, ...(data !== undefined ? { data } : {}) })
    if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES)
    localStorage.setItem(KEY, JSON.stringify(entries))
  } catch { /* storage full — non-critical */ }
}

export function getDebugLog(): DebugEntry[] {
  return load().reverse()  // newest first
}

export function clearDebugLog(): void {
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
}
